// import DsfHome from "./home";
// import DsfPageHomeHeaderUser from "./headerUser";
// import DsfPageHomeHeaderUserInfoPanel from "./headerUserInfoPanel";
// import DsfPersonalization from "./Personalization";
import homeDefault from "./default";
import homeTemplate1 from "./template1";
import homeGw from "./gw";
// import DsfMultiPageHome from "./multiPage/home";
// import DsfCollegeHome from "./college/home";

export default {
  install(Vue) {
    Vue.component("DsfHome", Vue.defineLazyComponent(()=>require("./home")));
    Vue.component("DsfPageHomeHeaderUser", Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_home" */ "./headerUser")));
    Vue.component("DsfPageHomeHeaderUserInfoPanel", Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_home" */ "./headerUserInfoPanel.vue")));
    Vue.component("DsfPersonalization", Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_home" */ "./Personalization")));
    Vue.component("DsfMultiPageHome", Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_home" */ "./multiPage/home")));
    Vue.component("DsfCollegeHome", Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_home" */ "./college/home")));
    //平台默认风格
    Vue.use(homeDefault);
    //平台默认风格模板1
    Vue.use(homeTemplate1);
    //组工产品菜单风格
    Vue.use(homeGw);
  }
};
